import React, { useEffect } from "react";
import { Button, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useBillModel } from "./billModel";
import { IBillDetail } from "../../../../../bill/BillTypes";
import { useDetailModel } from "../detailModel";
import { billStatusRender, ioFlagRender } from "@/types/FmsRender";
import { TradeTypeEnum } from "@/types/FmsEnums";
import BillDetailRender from "@/views/vrmBill";
import { billDetailRenderModel } from "@/views/vrmBill/bIllDetailRenderModel";
import YhTootip from "@/components/YhTootip";



export function BillDataTable() {
    const {
        dataSource,
        selectedRowKeys,
        pgCfg,
        loadData,
        selectedData,
        setSelectedRowKeys,
        setSelectedData,
        resendMsg,
    } = useBillModel();

    const { goToBill } = billDetailRenderModel();

    const {
        payMethodLabels,
    } = useDetailModel()

    const columns: ColumnsType<IBillDetail> = [
        {
            align: "center",
            width: 50,
            // ellipsis: true,
            title: '序号',
            render: (v, r, i) => i + 1
        },
        {
            align: "center",
            width: 200,
            title: '单据编号',
            dataIndex: 'tradeCode',
            // render: (t, r) => BillDetailRender(t, r)
            render: (text, recode) => <YhTootip text={text} onClick={() => goToBill(text, recode)} />
        },
        {
            align: "center",
            title: '客户名称',
            width: 200,
            dataIndex: 'partnerName',
            render: (text, recode) => <YhTootip text={text}  />
        },
        {
            align: "center",
            title: '单据金额',
            dataIndex: 'billAmount',
            width: 100,
            render: (text, record) => (
                record.tradeTypeCode === TradeTypeEnum.SALE_RETURN ||
                record.tradeTypeCode === TradeTypeEnum.PURCHASE_RETURN ||
                record.tradeTypeCode === TradeTypeEnum.BILL_FAVORABLE) ? Math.abs(text) : text
        },
        {
            align: "center",
            title: '支付类型',
            dataIndex: 'payType',
            width: 100,
            render: v => payMethodLabels[v] ?? '暂无'
        },
        {
            align: "center",
            title: '备注',
            width: 100,
            dataIndex: 'note',
            render: (text, recode) => <YhTootip text={text} />
        },
        {
            align: "center",
            // width: 100,
            // ellipsis: true,
            title: '账户类型',
            dataIndex: 'accountTypeName',
            width: 100,
        },
        {
            align: "center",
            title: '分支',
            dataIndex: 'branch',
            width: 100,
        },

        {
            align: "center",
            title: '单据类型',
            dataIndex: 'tradeTypeName',
            width: 100,
        },
        {
            align: "center",
            title: '优惠类型',
            dataIndex: 'preferentialTypeName',
            render: v => v ?? '暂无',
            width: 100,
        },
        {
            align: "center",
            title: '账单编码',
            dataIndex: 'code',
            width: 140,
            
        },
        {
            align: "center",
            title: '账户名称',
            dataIndex: 'accountName',
            render: (text, recode) => <YhTootip text={text}  />

        },
        {
            align: "center",
            title: '实体',
            dataIndex: 'beName',
            render: (text, recode) => <YhTootip text={text}  />

        },
        {
            align: "center",
            title: '收支类型',
            dataIndex: 'ioFlag',
            render: ioFlagRender,
            width: 100,
        },
        {
            align: "center",
            title: '收款状态',
            dataIndex: 'status',
            render: billStatusRender,
            width: 100,
        },
        {
            align: "center",
            title: '从属机构',
            dataIndex: 'orgName',
            width: 150,
            render: (text, recode) => <YhTootip text={text}  />
        },
        {
            align: "center",
            title: '记账日期',
            dataIndex: 'createTime',
            width: 200,
        },
        {
            align: "center",
            title: '业务员',
            dataIndex: 'tradeOperator',
            width: 100,
        },
        {
            align: "center",
            title: '核销日期',
            dataIndex: 'writeoffTime',
            width: 200,
        },
        {
            align: "center",
            title: '核销人',
            dataIndex: 'writeoffUser',
            width: 100,
        },
        {
            align: "center",
            title: '取消状态',
            dataIndex: 'cancelStatus',
            width: 100,
            render: (v) => v === 0 ? '初始' : v === 1 ? '审核中' : v === 2 ? '已取消' : v === 9 ? '异常 ' : ''
        },
        {
            align: "center",
            title: '操作',
            dataIndex: 'status',
            fixed: 'right',
            width: 100,
            render: (v, r) => v === 2 ? <Button type="link" shape="round" size="small" onClick={() => resendMsg(r?.code as string)}>重发</Button> : ''
        },
    ];


    return (
        <Table
            rowSelection={{
                type: "checkbox",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IBillDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                    setSelectedData(selectedRows)
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showSizeChanger: true,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.findIndex(item => item === record.key) !== -1) {
                            setSelectedRowKeys(arr => arr.filter(item => item !== record.key));
                            setSelectedData(arr => arr.filter(item => item.key !== record.key))
                        } else {
                            setSelectedRowKeys([...selectedRowKeys, record.key]);
                            setSelectedData([...selectedData, record])
                        }
                    },
                };
            }}
            scroll={{ x: 'max-content',y: "calc(100vh - 680px)" }}
        />
    )
}
